import { Service } from "axios-middleware";
import axios from "axios/index";

const service = new Service(axios);

service.register({
  onRequest(config) {
    config.headers.urbancanvastk = localStorage.getItem("id_token");
    return config;
  }
});

export default service;
